import {
  WSBadge,
  WSButton,
  WSFlexBox,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { RouteComponentProps, useHistory } from "react-router-dom";
import { CreditCardLogoCircle } from "../../../components/CreditCardBrandLogo/CreditCardLogoCircle";
import { DetailsLayout } from "../../../components/DetailsLayout/DetailsLayout";
import { useInstantPayoutQuery } from "../../../query/payments/queries";
import { WSQueries } from "../../../query/WSQuery";
import {
  getInstantPayoutCardName,
  stripeCardBrandToCreditCardType
} from "../../../types/creditCard";

export const CardDetails: React.FC<RouteComponentProps<{
  instantPayoutAccountId: string;
}>> = () => {
  const history = useHistory();

  const instantPayoutQuery = useInstantPayoutQuery();

  return (
    <DetailsLayout
      onBack={() => {
        history.push("/member/settings/payment-methods");
      }}
      title="Card info"
    >
      <WSQueries queries={{ instantPayoutQuery }}>
        {({ instantPayoutQuery: { data: instantPayout } }) => {
          return (
            <DetailsLayout.Card>
              <WSFlexBox.CenterY wrap="nowrap" justify="space-between" mb="M">
                <WSFlexBox.CenterY wrap="nowrap">
                  <CreditCardLogoCircle
                    mr="M"
                    type={stripeCardBrandToCreditCardType(
                      instantPayout.instantPayoutAccount.numbers.brand
                    )}
                  />
                  <WSText.Heading4>
                    {getInstantPayoutCardName(instantPayout)}
                  </WSText.Heading4>
                </WSFlexBox.CenterY>

                <WSBadge
                  backgroundColor="green200"
                  textProps={{ color: "green500", singleLine: true }}
                  text="Payout Method"
                />
              </WSFlexBox.CenterY>

              <WSButton
                fullWidth
                onClick={() => {
                  history.push(
                    "/member/settings/payment-methods/add-payout-method/card"
                  );
                }}
              >
                Replace payout card
              </WSButton>
            </DetailsLayout.Card>
          );
        }}
      </WSQueries>
    </DetailsLayout>
  );
};
